import service from '@/plugins/service'

const base = 'auth/role'

export const getRoleList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const searchRoleList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addRole = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const updateRole = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const removeRole = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const getRole = (id, lang='zh-CN') => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      id,
      lang
    }
  })
}
